import { Hero } from "../sections/Hero";
import { PhoneScene } from "../sections/PhoneScene";
import { Problem } from "../sections/Problem";
import { HowItWorks } from "../sections/HowItWorks";
import { WhyReactivation } from "../sections/WhyReactivation";
import { OngoingSystem } from "../sections/OngoingSystem";
import { Benefits } from "../sections/Benefits";
import { BeforeAfter } from "../sections/BeforeAfter";
import { TwoPaths } from "../sections/TwoPaths";
import { Proof } from "../sections/Proof";
import { FaqPreview } from "../sections/Faq";
import { Discovery, FinalCTA } from "../sections/Conversion";

export default function Home() {
    return (
        <main data-testid="home-page">
            <Hero />
            <Problem />
            <PhoneScene />
            <HowItWorks />
            <WhyReactivation />
            <OngoingSystem />
            <Benefits />
            <BeforeAfter />
            <TwoPaths />
            <Proof />
            <FaqPreview />
            <Discovery />
            <FinalCTA />
        </main>
    );
}
